var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FiltersTemplate',{attrs:{"inputFilters":_vm.inputFilters,"adminFilters":_vm.adminFilters}}),_c('AlertExpirePassword'),_c('ConversionLayout',{staticClass:"kt-container",attrs:{"displayCreate":false,"displayChart":true,"APIslug":'conversion',"tabsData":_vm.tabsData,"inputFilters":_vm.inputFilters,"adminFilters":_vm.adminFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }